import { Box, Divider, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { StylesForm } from '../../../styles/global';

// Widget for Project Display Request
const InformProjectDisplayRequest = ({
  project,
  dueDate,
  showLink = false,
}) => {
  const { pid } = useParams();
  return (
    <>
      {project && (
        <>
          {/* Project Title + Due Date */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {/* Project Title */}
            <Typography {...StylesForm.text('h6')}>Display Request</Typography>
            <Divider />

            {/* Due Date */}
            <Typography
              {...StylesForm.text('p')}
              sx={{
                marginBottom: 1,
                color: '#226E93',
              }}
            >
              (due {dueDate || 'unassigned'} )
            </Typography>
          </Box>

          <Divider />

          {/* Abstract */}

          <Typography
            {...StylesForm.text('p')}
            sx={{
              marginBottom: 1,
              color: 'darkslategray',
              whiteSpace: 'pre-line',
              overflowY: 'auto',
              height: '100%',
            }}
          >
            {!project.data.displayRequest
              ? 'No display request submitted.'
              : project.data.displayRequest}
          </Typography>

          {/* Link to add abstract */}
          {showLink && (
            <Box display={'flex'} alignItems={'end'} flex={2}>
              <Link
                to={`/student/dashboard/project/${pid}/display-request`}
                style={{ color: '#1976D2', margin: 3 }}
              >
                {' '}
                To submit the display request, click here{' '}
              </Link>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default InformProjectDisplayRequest;
